import { render, staticRenderFns } from "./provisionalBill.vue?vue&type=template&id=6f9da240&scoped=true&"
import script from "./provisionalBill.vue?vue&type=script&lang=js&"
export * from "./provisionalBill.vue?vue&type=script&lang=js&"
import style0 from "./provisionalBill.vue?vue&type=style&index=0&id=6f9da240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9da240",
  null
  
)

export default component.exports